<template>
  <div>
    <layout-header/>
    <div class="page-content">
      <layout-sidebar/>
      <div class="content-wrapper">
        <layout-page-header/>
        <div class="content">
          <router-view :key="$route.fullPath"/>
        </div>
        <layout-footer/>
      </div>
    </div>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import SideBar from "@/components/layout/SideBar";
import PageHeader from "@/components/layout/PageHeader";
import Footer from "@/components/layout/Footer";
import CardReload from "@/components/block/BlockTarget";
import '@/assets/mod_ums.css';

export default {
  components: {
    'layout-page-header':PageHeader,
    'layout-sidebar': SideBar,
    'layout-header':Header,
    'layout-footer':Footer,
    // eslint-disable-next-line vue/no-unused-components
    'block-card-reload':CardReload
  },
  name: 'app',
  created() {
    this.$store.dispatch(this.$const.ACTIONS.SET_SENDER_LIST)
  }
}


</script>

<style>
  .page-content {
    min-height: calc(100vh - 50px);
    box-sizing: border-box;
  }


</style>
